import type { ContactCtaModelProps } from '@/components/shared/contact-cta/contact-cta.model'
import { useContactCtaModel } from '@/components/shared/contact-cta/contact-cta.model'
import { ContactCtaView } from '@/components/shared/contact-cta/contact-cta.view'

export function ContactCtaViewModel(props: ContactCtaModelProps) {
  const model = useContactCtaModel(props)
  return <ContactCtaView {...model} />
}
